import React, { useState } from "react";

import Card from "./shared/Card";
import UploadComponent from "./UploadComponent";
import ImageDropdown from "./ImageDropdown";
import PlusButton from "./shared/PlusButton";

const SourceImage = ({ sourceImage, setSourceImage, small=false }) => {
    const [uploadVisible, setUploadVisible] = useState(false);
    console.log("sourceImage", sourceImage);
    console.log("UploadVisible", uploadVisible);

    return (
        <Card>
            {!uploadVisible && (
                <div className="flex flex-grow w-full items-center space-x-4">
                    <div className="flex-grow">
                        <ImageDropdown selectedIndex={SourceImage?.id} onSelect={(image) => setSourceImage(image)} />
                    </div>
                    <PlusButton
                        onClick={() => setUploadVisible(true)}
                        className="mb-4"
                    />
                </div>


            )}

            {uploadVisible && (
                <div className="w-full relative">
                    <UploadComponent
                        mediaType="image"
                        setSourceMedia={setSourceImage}
                        uploadText={"Upload an image"}
                        setUploadVisible={setUploadVisible}

                    //   onUploadSuccess={handleImageUploadSuccess} 
                    />
                </div>
            )}
            {sourceImage && (
                <div className="w-full mt-4 flex justify-center">

                    <img
                        src={sourceImage.s3_url}
                        alt="Uploaded Image"
                        className={`w-auto max-h-full ${small ? "h-[100px]" : "max-w-full"} mx-auto`}
                    />
                </div>

            )}
        </Card>
    );
}

export default SourceImage;